import { bffServiceClient } from 'packages/request/clients';
import { getData, getResult } from 'helpers/request';
import {
  IGetLeadApproachingReq,
  IGetLeadApproachingResp,
  IGetLeadStatusesResp,
  ILeadBySearchResponse,
  ILeadDetail,
  ITagItem,
  IUpdateTicketApproachLead,
} from 'interfaces/lead';

const getLeadBySearch = (params: {
  searchText?: string;
}): Promise<ILeadBySearchResponse> => {
  if (params.searchText === undefined || params.searchText === '') {
    return new Promise(resolve => {
      resolve({ code: '', message: '', data: { leads: [] } });
    });
  }
  return bffServiceClient
    .get('/leads/search', {
      params,
    })
    .then(getResult);
};

const getLeadDetail = (leadId: number): Promise<ILeadDetail> => {
  return bffServiceClient.get(`/lead/${leadId}`).then(getData);
};

const getLeadStatus = (): Promise<IGetLeadStatusesResp> => {
  return bffServiceClient.get('/lead/lead-statuses').then(getData);
};

const getTags = (searchTag?: string): Promise<{ tags: ITagItem[] }> => {
  return bffServiceClient
    .get('/lead/tags', {
      params: { searchTag: searchTag },
    })
    .then(getData);
};

const createTags = (tagNames: string[]): Promise<{ tags: ITagItem[] }> => {
  return bffServiceClient
    .post('/lead/tags', { tagNames: tagNames })
    .then(getData);
};

const updateTicketApproachLead = (
  payload: IUpdateTicketApproachLead
): Promise<{ ticketId: number }> => {
  return bffServiceClient
    .post('/lead/update-ticket-approach-lead', payload)
    .then(getData);
};

const getLeadApproaching = (
  params: IGetLeadApproachingReq
): Promise<IGetLeadApproachingResp> => {
  return bffServiceClient
    .get('/lead/lead-approaching', { params: params })
    .then(getData);
};

const exportLeadApproaching = (
  params: IGetLeadApproachingReq
): Promise<{ filePath: string }> => {
  return bffServiceClient
    .get('/lead/lead-approaching/download', { params: params })
    .then(getData);
};

export default {
  getLeadBySearch,
  getLeadDetail,
  getLeadStatus,
  getTags,
  createTags,
  updateTicketApproachLead,
  getLeadApproaching,
  exportLeadApproaching,
};
